import { API, endpoints } from 'src/api';
import useSWR from 'swr';

export interface CategoryModulesType {
  modules: {
    type: 'medium-card';
    category: {
      label?: string;
      translationKey: string;
      slug: string;
    };
    items: any[];
  }[];
  category: {
    name: string;
    slug: string;
    description: string;
  };
}

export const useCategoryModules = ({
  slug,
  pageNumber,
}: {
  slug: string | string[] | undefined;
  pageNumber: number;
}) => {
  endpoints.category.slug = slug as string;
  endpoints.category.start_page = pageNumber;
  endpoints.category.limit_page = 3;

  const { data, error } = useSWR(endpoints.category.url, API.get);
  const categoryData: CategoryModulesType = {
    modules: [],
    category: {
      description: '',
      name: '',
      slug: '',
    },
  };
  if (data?.data) {
    if (data.data?.tops) {
      categoryData.modules.push({
        type: 'medium-card',
        category: {
          label: 'Top of the charts',
          translationKey: 'dashboard-recommended-title',
          slug: 'top-charts',
        },
        items: data?.data.tops,
      });
    }
    categoryData.modules.push({
      type: 'medium-card',
      category: {
        label: 'All modules',
        translationKey: 'dashboard-recommended-title',
        slug: 'all-modules',
      },
      items: data?.data.items,
    });
    categoryData.category = { ...data.data.category };
  }
  return {
    categoryData,
    isLoading: !error && !data,
    error,
  };
};

export const useCatalogModules = ({ start, isHideMyLessons }) => {
  endpoints.catalog.start_page = start;
  endpoints.catalog.limit_page = 3;
  endpoints.catalog.limit_card = 0;
  endpoints.catalog.start_card = 0;
  endpoints.catalog.hide_my_lessons = isHideMyLessons ? 1 : 0;
  const { data, error } = useSWR(endpoints.catalog.url, API.get);
  let catalogData: any = null;
  if (data?.data.latest || data?.data.promoted || data?.data.lessons) {
    catalogData = [];
    if (data?.data.latest) {
      catalogData.push({
        type: 'cover-card',
        items: [data.data.latest],
        category: {
          label: 'Fresh off the press',
        },
      });
    }

    if (data?.data.recommended) {
      catalogData.push({
        type: 'medium-card',
        items: [...data.data.recommended],
        category: {
          label: 'We recommend',
          slug: 'recommendations',
        },
      });
    }
    if (data?.data.promoted) {
      catalogData.push({
        type: 'promo-card',
        items: [...data.data.promoted],
        category: {
          label: 'Our top hits',
        },
      });
    }
    if (data.data.lessons) {
      catalogData.push(...data.data.lessons);
    }
  }
  return {
    catalogData,
    isLoading: !error && !data,
    error,
    hasMore: data?.data?.length !== 0,
  };
};
